import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable ,  BehaviorSubject } from 'rxjs';

// Add the RxJS Observable operators we need in this app.
import '../../../../node_modules/rxjs/operators';

import { BaseService } from "./base.service";
import { ConfigService } from '../utils/config.service';
import { SettingsModel } from '../../configuration/models';

@Injectable()
export class SettingsService extends BaseService {

    baseUrl: string = '';

    // // Observable navItem source
    // private _authNavStatusSource = new BehaviorSubject<boolean>(false);
    // // Observable navItem stream
    // authNavStatus$ = this._authNavStatusSource.asObservable();

    // private loggedIn = false;

    constructor(private httpClient: HttpClient, private configService: ConfigService) {
        super();
        // this.loggedIn = !!localStorage.getItem('auth_token');
        // // ?? not sure if this the best way to broadcast the status but seems to resolve issue on page refresh where auth status is lost in
        // // header component resulting in authed user nav links disappearing despite the fact user is still logged in
        // this._authNavStatusSource.next(this.loggedIn);

        this.baseUrl = configService.getApiURI();
    }

    getSetting(settingValue: string): Observable<SettingsModel> {
        const params = new HttpParams().set('settingsID', settingValue);
        return this.httpClient.get<SettingsModel>(this.baseUrl + '/Settings/GetSetting', { params });
    }
    
    getAppropriateUsePolicy(): Observable<SettingsModel> {
        return this.httpClient.get<SettingsModel>(this.baseUrl + '/Settings/GetAppropriateUsePolicy');
    }
}
